import { configureAuth } from "react-query-auth";
import { getExonnApi } from "src/exonn-api/exonn-api.tsx";
import type { AuthPaths } from "@exonn/js-sdk";
import type { UserResource } from "@exonn/js-sdk";

export const { useUser, useLogin, useLogout } = configureAuth<
  UserResource,
  any,
  AuthPaths.LoginBrowser.RequestBody,
  any
>({
  userFn: async ({ signal }) => {
    const api = getExonnApi();
    const response = await api.auth.getAuthenticatedUser(null, null, {
      signal,
    });
    return response.data.data;
  },
  loginFn: async (credentials) => {
    const api = getExonnApi();
    const response = await api.auth.loginBrowser(null, credentials);
    return response.data.data;
  },
  registerFn: () => {
    throw new Error("not implemented");
  },
  logoutFn: () => {
    const api = getExonnApi();
    return api.auth.logoutBrowser(null, null);
  },
});
